import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'

import { type AsyncSelectState } from './model'

export const initialState: AsyncSelectState = {
  status: 'initial',
  loading: false,
  searching: false,
  initialOptions: [],
  initialOptionsCount: 0,
  searchOptions: [],
  searchOptionsCount: 0,
}

export const asyncSelectState = atomFamily(
  (_key: string) => atom<AsyncSelectState>(initialState),
  (a, b) => a === b,
)
